<div>
    <label *ngIf="label">
        {{label}}
        <span *ngIf="control.hasValidator(requiredValidator)" class="required-asterisk">*</span>
    </label>
</div>
<mat-radio-group [formControl]="control">
    <mat-radio-button
        *ngFor="let option of options"
        [value]="option.value ? option.value : option">
        {{option.label ? option.label : option}}
    </mat-radio-button>
</mat-radio-group>
